import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/affirmation/importer/affirmationImporterActions';

export default importerReducers(actions);
